export const questions = [
  'Asked strangers to move out of your shot',
  'Complained about traffic as small talk',
  'Attended an "exclusive" invite-only party (that wasn\'t)',
  'Name-dropped someone you met once as a friend',
  "Been to a 'VIP' section that was just a roped-off corner",
  'Bought an Erewhon smoothie over $20',
  "Been to a 'networking mixer' where no one had a job",
  'Done the slow-mo walk toward camera',
  'Have asked "Who\'s gonna be there?"',
  'Made someone retake your photo 15+ times',
  "Used 'manifesting' to explain why something good happened",
  "Asked someone's follower count within 5 minutes of meeting them",
  'Said "I\'m actually from here" defensively',
  'Call highways by "the" like the 10, the 405',
  'Done a Runyon hike for networking',
  "Referred to your followers as your 'community'",
  'Walked past a line by saying "I\'m on the list."',
  'Said "I\'m obsessed" about something you used once',
  'Judged someone by what part of LA they live in',
  'Recorded yourself fake-laughing at your phone',
  'Have opinions about Soho House',
  'Filmed a "day in my life" that was 90% staged',
  'Photographed yourself at the Paul Smith pink wall on Melrose',
  "Talked about being authentic more than you've been authentic",
  'Rented a nicer car for a photo/video',
  'Said "let\'s collab" to a stranger',
  'Have "📍LA" in your bio',
  'Called Griffith "touristy" but still go',
  'Posted "my DMs are open" like you\'re a public service',
  "Described yourself as a 'multi-hyphenate'",
  'Blocked traffic for a photo',
  "Been to a party in the Hills where you didn't know the host",
  'Brought my camera to a party "just in case."',
  'DM\'d "Would love to collab" to someone I\'ve never met',
  'Collected IG handles like Pokémon',
  "Posted a Venice canals walk like it's hidden",
  'Called In-N-Out "overrated" publicly (secretly love it)',
  'Started a vlog and forgot to vlog',
  "Been recognized once and haven't stopped talking about it",
  'Taken laptop + matcha photos without doing any work',
  'Said "I\'m 20 minutes away" knowing it\'s 55',
  'Been intentionally vague about plans to seem busy',
  'Filmed a workout set in a public gym',
  'Said "Pilates changed my life."',
  'Posted a thirst trap disguised as a "feeling grateful" post',
  'Said "I\'m so bad at self-promo" while self-promoting',
  'Dated someone who "works in entertainment" (no further details)',
  'Said "You guys have been asking…" when nobody asked',
  'Cried on camera',
  'Written "can\'t believe this is my life."',
  'Written "still processing" for no reason',
  'Been to a content house',
  'Bought followers (be honest)',
  'Bought something because a creator said it "changed their life."',
  'Posted "soft launching my new project" three times',
  'Said "the energy here is just different"',
  'Posted "thank you for having me" to a brand that did not host me',
  'Posted a "day in my life in LA" more than once',
  "Claimed to be 'bi-coastal' because you visit NYC once a year",
  'Have a vision board as your phone wallpaper',
  'Done a sound bath',
  'Filmed in a store and got asked to stop',
  'Tagged every brand in the background',
  'Called a celebrity interaction "my claim to fame"',
  'Used the phrase "high value" to describe a person',
  'Posted a traffic photos like it was breaking news',
  'Said "use my code" in real life',
  'Been in a "situationship"',
  'Said "dating here is insane" as a personality trait',
  'Held my phone while running for content',
  'Changed outfits in a car',
  'Filmed a "get ready with me" and did not go anywhere',
  'Screenshot your own analytics to share',
  'Risked my life for a "fit pic."',
  'Have a specialized diet (keto, paleo, vegan) that changes monthly',
  'Chosen a restaurant based on chair aesthetics',
  "Rearranged someone else's food for a shot",
  'Called brunch "a cultural experience"',
  'Said "it gets dark so early?"',
  'Asked "What neighborhood?" before "What\'s your name?"',
  "Listed your Myers-Briggs like it's a personality",
  'Deleted a post because it underperformed',
  'Done an ice bath for content',
  'Filmed a "car vlog" in a parked car',
  "Posted your car in front of a nice house that isn't yours",
  'Commented on your own post from a burner',
  "Tagged brands that didn't gift you hoping they'd notice",
  'Have said "I\'m actually really introverted" at a party',
  'Checked who liked my post from the gym',
  'Brought a change of clothes "just in case"',
  'Taken pics at the LACMA lamp posts',
  "Inserted yourself into drama that wasn't yours",
  'Changed my niche more than my sheets',
  'Posted "I\'ve grown" after being caught',
  'Used your pet for engagement when your content flopped',
  'Called yourself an "actor/model" with no experience',
  'Changed your whole personality after one video did well',
  "Can't have fun without posting proof",
  'Made your whole identity about living in LA',
  "Actually believe you're going to make it (we hope you do!)",
]
